import { type ReactElement } from 'react'
import type BenefitProps from './benefit-card.props'
import * as S from './benefit-card.styled'

export default function BenefitCard ({ description, icon, title }: BenefitProps): ReactElement {
  return <S.Container>
    <div>
      <figure>
        <img src={icon} alt="" />
      </figure>
      <h4>{title}</h4>
    </div>
    <p>{description}</p>
  </S.Container>
}
